import React from "react";

const TOPICS = [
  ["×", "#FF8A3D", "Times tables"],
  ["10", "#3B7DD8", "Place value"],
  ["½", "#1F8A5B", "Fractions"],
  ["£", "#E5604E", "Money"],
  ["◷", "#171A36", "Telling the time"],
  ["+", "#FF8A3D", "Adding & subtracting"],
  ["÷", "#3B7DD8", "Division"],
  ["△", "#1F8A5B", "Shapes"],
  ["cm", "#E5604E", "Measuring"],
  ["▥", "#171A36", "Charts & data"],
  ["%", "#FF8A3D", "Decimals & percentages"],
  ["10", "#3B7DD8", "Number bonds"],
];

export default function Topics() {
  const row = [...TOPICS, ...TOPICS];
  return (
    <div className="marquee-block" aria-label="Topics Leo covers">
      <p className="marquee-label">Everything on the National Curriculum, Year 1 to Year 6</p>
      <div className="marquee">
        <div className="marquee-track">
          {row.map(([glyph, color, name], n) => (
            <span className="topic" key={n} aria-hidden={n >= TOPICS.length}>
              <em style={{ background: color }}>{glyph}</em>
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
